import { createContext } from "react";
import { iEnquiry } from "../interfaces/iEnquiry";

export const ReplaceEnquiryOwnershipContext = createContext((enquiries: Array<iEnquiry>) => {});
